import { Navbar } from "./components/Navbar/Navbar";
import { Hero } from "./components/Hero/Hero";
import { Services } from "./components/Services/Services";
import { WhyJalaram } from "./components/WhyJalaram/WhyJalaram";
// import { Showcase } from "./components/Showcase/Showcase";
import { Industries } from "./components/Industries/Industries";
import { CTA } from "./components/CTA/CTA";
import { Footer } from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyJalaram />
        {/* <Showcase /> */}
        <Industries />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

export default App;
